import r from "./_isArrayLike.js";
import t from "./keys.js";
import e from "./_optimizeCb.js";
function o(o) {
  var n = function n(e, _n, i, a) {
    var f = !r(e) && t(e),
      u = (f || e).length,
      m = o > 0 ? 0 : u - 1;
    for (a || (i = e[f ? f[m] : m], m += o); m >= 0 && m < u; m += o) {
      var s = f ? f[m] : m;
      i = _n(i, e[s], s, e);
    }
    return i;
  };
  return function (r, t, o, i) {
    var a = arguments.length >= 3;
    return n(r, e(t, i, 4), o, a);
  };
}
export { o as default };